import { createGlobalState } from 'react-use';

export const useReportStorageReady = createGlobalState(true);
